module.exports = __webpack_public_path__ + "img/pic_follow_bigsale2@2x.fc3a1219.png";